import { useOutletContext } from 'react-router-dom'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarList } from '@factorialco/f0-react'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { MyTrainingsCatalogTrainingFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export const Overview = () => {
  const { training } = useOutletContext<{ training: MyTrainingsCatalogTrainingFragment }>()
  const instructors = training?.sessionsConnection?.nodes?.length
    ? training?.sessionsConnection?.nodes?.flatMap((session) =>
        session.sessionInstructors.map((instructor) => ({
          firstName: instructor.employee.firstName,
          lastName: instructor.employee.lastName,
          type: 'person' as const,
          src: buildUrl(instructor.employee?.avatar?.url ?? ''),
        }))
      )
    : []
  return (
    <Box flexDirection="row" gap="s24">
      <Box style={{ flex: '2' }} gap="s24" paddingRight="s120">
        <Box gap="s8">
          <Text.Normal size="300" weight="semibold" color="textPrimary">
            {i18n.t('trainings.my_trainings_revamp.training_detail.overview.competencies')}
          </Text.Normal>
          <Box gap="s8" flexDirection="row" flexWrap="wrap">
            {training.competencies?.length
              ? training.competencies.map((competency) => (
                  <Box key={competency.id}>
                    <Tag type="malibu">{competency.name}</Tag>
                  </Box>
                ))
              : '-'}
          </Box>
        </Box>
        <Box gap="s8">
          <Text.Normal size="300" weight="semibold" color="textPrimary">
            {i18n.t('trainings.my_trainings_revamp.training_detail.overview.objectives')}
          </Text.Normal>
          <Box>
            <RichTextDisplay content={training?.objectives || ''} />
          </Box>
        </Box>
        <Box gap="s8">
          <Text.Normal size="300" weight="semibold" color="textPrimary">
            {i18n.t('trainings.my_trainings_revamp.training_detail.overview.description')}
          </Text.Normal>
          <Box>
            <RichTextDisplay content={training?.description || ''} />
          </Box>
        </Box>
        {instructors?.length > 0 && (
          <Box gap="s8">
            <Text.Normal size="300" weight="semibold" color="textPrimary">
              {i18n.t('trainings.my_trainings_revamp.training_detail.overview.instructors')}
            </Text.Normal>

            <F0AvatarList avatars={instructors} size="sm" type="person" max={3} />
          </Box>
        )}
        {training?.learningPlatform && (
          <Box gap="s8">
            <Text.Normal size="300" weight="semibold" color="textPrimary">
              {i18n.t('trainings.my_trainings_revamp.training_detail.overview.learning_platform')}
            </Text.Normal>
            <Box>
              <Text.Normal>{training?.learningPlatform?.link}</Text.Normal>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}
